module.exports = __webpack_public_path__ + "img/pers-labels.06847d09.jpg";